import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ShoppingBag, Download, Package } from "lucide-react";
import { toast } from "sonner";

export default function Shop() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("toate");
  const [loadingSlug, setLoadingSlug] = useState(null);

  useEffect(() => {
    api.get("/shop/products").then(r => setItems(r.data || [])).catch(() => {});
  }, []);

  const filtered = filter === "toate" ? items : items.filter(i => i.product_type === filter);

  const buy = async (p) => {
    setLoadingSlug(p.slug);
    try {
      const { data } = await api.post("/shop/checkout", {
        items: [{ slug: p.slug, qty: 1 }],
        origin_url: window.location.origin,
        customer: {},
      });
      window.location.href = data.url;
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Eroare la checkout");
      setLoadingSlug(null);
    }
  };

  return (
    <div data-testid="page-shop" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-20">
      <header className="mb-10">
        <p className="text-xs tracking-[0.3em] text-[#D4A63D] uppercase mb-4">Resurse & accesorii</p>
        <h1 className="font-display text-4xl md:text-6xl text-[#F8F8F4]">Shop</h1>
        <p className="mt-4 text-[#A0AABF] text-lg max-w-3xl">Fiecare achiziție sprijină dezvoltarea acestei platforme și misiunea de conștientizare.</p>
      </header>

      <div className="flex gap-2 mb-8">
        {[
          { v: "toate", l: "Toate" },
          { v: "digital", l: "Digital" },
          { v: "physical", l: "Fizic" },
        ].map(f => (
          <button key={f.v} onClick={() => setFilter(f.v)} data-testid={`shop-filter-${f.v}`} className={`px-4 py-2 text-sm rounded-sm ${filter === f.v ? "bg-[#D4A63D] text-[#0A1020]" : "bg-white/5 text-[#A0AABF] hover:bg-white/10"}`}>{f.l}</button>
        ))}
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {filtered.map(p => {
          const price = p.sale_price ?? p.price;
          return (
            <article key={p.product_id} data-testid={`prod-${p.slug}`} className="cinematic-card rounded-lg overflow-hidden flex flex-col">
              <div className="relative aspect-[4/3] overflow-hidden">
                <img src={p.thumbnail} alt={p.title} className="absolute inset-0 w-full h-full object-cover hover:scale-105 transition-transform duration-700" />
                <div className="absolute top-3 left-3 text-[10px] uppercase tracking-widest text-[#D4A63D] bg-[#0A1020]/85 px-2 py-1 border border-[#D4A63D]/30 flex items-center gap-1.5">
                  {p.product_type === "digital" ? <><Download className="w-3 h-3" /> Digital</> : <><Package className="w-3 h-3" /> Fizic</>}
                </div>
                {p.sale_price && <div className="absolute top-3 right-3 text-[10px] bg-[#C83A3A] text-white px-2 py-1 uppercase tracking-widest">Reducere</div>}
              </div>
              <div className="p-5 flex-1 flex flex-col">
                <h3 className="font-display text-lg text-[#F8F8F4] leading-snug">{p.title}</h3>
                <p className="text-sm text-[#A0AABF] mt-2 flex-1">{p.description}</p>
                <div className="mt-4 flex items-end justify-between">
                  <div>
                    {p.sale_price ? (
                      <>
                        <span className="text-xs text-[#6C7A9C] line-through mr-2">{p.price} RON</span>
                        <span className="font-display text-2xl gold-text">{price} RON</span>
                      </>
                    ) : (
                      <span className="font-display text-2xl gold-text">{price} RON</span>
                    )}
                  </div>
                  <button data-testid={`buy-${p.slug}`} onClick={() => buy(p)} disabled={loadingSlug === p.slug} className="btn-gold rounded-sm px-4 py-2 text-xs uppercase tracking-widest font-medium disabled:opacity-50 inline-flex items-center gap-1.5">
                    <ShoppingBag className="w-3.5 h-3.5" /> {loadingSlug === p.slug ? "..." : "Cumpără"}
                  </button>
                </div>
              </div>
            </article>
          );
        })}
      </div>
    </div>
  );
}
